import React from 'react'
import tvImg from "../../asstes/tv.webp"
const DeskTopView = () => {
    return (
        <>
            <div className='container mx-auto px-4  md:container md:mx-auto py-16 bg-gradient-to-t from-pink-500 to-purple-500'>
                <h1 className='text-white  text-5xl text-center font-bold py-4'>Convenient office</h1>
                <p className='text-gray-300 text-xl text-center'>Interactive online visualization of active slots showing your unique NFT collection and your
                    <br /> financial progress.</p>
                <img className='mx-auto' src={tvImg} alt="tv-img" />
            </div>
        </>
    )
}

export default DeskTopView